/* eslint-disable import/no-cycle */
import { get, map } from 'lodash'
import { ThunkResult } from '../index'
import { TEMPLATES, TEMPLATE } from './templateTypes'
import { getReq } from '../../utils/request'
import { IResetStore } from '../generalTypes'
import { IResponsePagination, ISelectOptionItem } from '../../types/interfaces'
import { PAGINATION } from '../../utils/enums'
import { formatDateWithTime, normalizeQueryParams } from '../../utils/helper'

export type TemplateActions = IResetStore | IGetTemplatesAction | IGetTemplateAction | any

interface IGetTemplatesAction {
	type: TEMPLATES
	payload: ITemplatesPayload
}

interface IGetTemplateAction {
	type: TEMPLATE
	payload: ITemplatePayload
}

export interface ITemplateItem {
	key: number
	id: number
	author: IAuthor
	deletedAt: string
	description: string
	name: string
	editor: IAuthor
	createdAt: string
	updatedAt: string
	formDatabase: string
	formFinalStatus: string
	formInputStoredProcedure: string
	formName: string
	formOutputStoredProcedureAfterSave: string
	formOutputStoredProcedureBeforeSave: string
	formQueue: IQueue
	finalStatus: string
	formItems: any[]
	inputStoredProcedure: string
	title: string
	state: boolean
	status: string
	formType: string

	created: ITemplateDateChange
	lastEdit: ITemplateDateChange
}

interface ITemplateDetailItem {
	id?: number
	name?: string
	description?: string
	formName?: string
	formDatabase?: string
	formQueue?: IQueue
	formType?: string
	formInputStoredProcedure?: string
	formOutputStoredProcedureBeforeSave?: string
	formOutputStoredProcedureAfterSave?: string
	formFinalStatus?: string
	createdAt?: number
	updatedAt?: number
	deletedAt?: number
	author?: any
	editor?: any
}

export interface ITemplateDateChange {
	date: number
	author: string
	id: string
}

export interface IQueue {
	id: number
	title: string
}

export interface IAuthor {
	id: number
	fullName: string
	officialName: string
}

export interface ITemplateTableItem {
	key: number
	id: number
	name: string
	description: string
	created: ITemplateDateChange
	lastEdit: ITemplateDateChange
	updatedAt: string
}

export interface ITemplatesPayload {
	originalData: ITemplateItem[] | null
	templatesOptions: ISelectOptionItem[] | null
	tableData: ITemplateTableItem[] | []
	pagination: IResponsePagination | null
}

export interface ITemplateDuplicatePayload {
	formName: string | null
}

export interface ITemplatePayload {
	data: ITemplateDetailItem | null
}

export const getTemplates =
	(page = 1, limit?: number | null, queryParams = {}): ThunkResult<Promise<any>> =>
	async (dispatch) => {
		try {
			dispatch({
				type: TEMPLATES.TEMPLATES_LOAD_START
			})
			const pageLimit = limit || PAGINATION.limit
			const { data } = await getReq('/api/admin/templates/', { page, limit: pageLimit, ...normalizeQueryParams(queryParams) })
			const originalData: ITemplateItem[] = get(data, 'data.templates')

			const tableData = map(originalData, (column) => ({
				key: column.id,
				id: column.id,
				description: column.description,
				name: column.name,
				created: {
					author: column?.author?.officialName,
					date: formatDateWithTime(column.createdAt)
				},
				lastEdit: {
					author: column?.editor?.officialName,
					date: formatDateWithTime(column.updatedAt),
					id: column?.editor?.id
				},
				updatedAt: column.updatedAt
			}))

			const payload = {
				originalData,
				tableData,
				pagination: get(data, 'data.pagination')
			}
			dispatch({
				type: TEMPLATES.TEMPLATES_LOAD_DONE,
				payload
			})

			return payload
		} catch (e) {
			dispatch({
				type: TEMPLATES.TEMPLATES_LOAD_FAIL
			})
			return e
		}
	}

export const getTemplate =
	(id?: string): ThunkResult<Promise<any>> =>
	async (dispatch) => {
		try {
			dispatch({ type: TEMPLATE.TEMPLATE_LOAD_START })
			const { data } = await getReq(`/api/admin/templates/${id}`, undefined)

			const payload = {
				data: get(data, 'data.template')
			}

			dispatch({ type: TEMPLATE.TEMPLATE_LOAD_DONE, payload })
			return payload
		} catch (e) {
			dispatch({ type: TEMPLATE.TEMPLATE_LOAD_FAIL })
			return e
		}
	}
